import {graphql} from '~/graphql-react-query/';

export const SubmitHubspotForm = graphql(`
    mutation SubmitForm($formId: String!, $formInput: [TrackingFormField!]!) {
        tracking {
            submitHubspotForm(formId: $formId, formInput: $formInput)
        }
    }
`);

export const SubmitUserCreatedAccountForm = graphql(`
    mutation SubmitUserCreatedAccountForm($country: SupportedCountry!) {
        tracking {
            submitUserCreatedAccountForm(country: $country)
        }
    }
`);
